import React from 'react'
import { IBadgeProps } from './interfaces'
import { ChromeFilled } from '@ant-design/icons'
import { Tooltip } from 'antd'
import { DeliveryChannel } from '@pushly/aqe/lib/enums/delivery-channels'

export const WebBadge: React.FC<React.PropsWithChildren<React.PropsWithChildren<IBadgeProps>>> = (props) => {
    const badge = (
        <span className="icon-chrome">
            <ChromeFilled />
        </span>
    )

    return (
        <span className="delivery-channel-web-badge">
            {props.hideTooltip ? (
                badge
            ) : (
                <Tooltip
                    title={props.tooltip || `Delivery Channel: ${DeliveryChannel.getLongName(DeliveryChannel.WEB)}`}
                >
                    {badge}
                </Tooltip>
            )}
        </span>
    )
}
